import { useEffect, useState } from "react";
import SectionLabel from "@/components/SectionLabel";
import { api } from "@/lib/api";
import { ChevronDown } from "lucide-react";

export default function FAQs() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/faqs").then(r => setItems(r.data)).catch(()=>{}); }, []);

  return (
    <div>
      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <SectionLabel>FAQ</SectionLabel>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900">Frequently asked questions.</h1>
          <p className="mt-3 text-slate-600">Can't find your answer? Please contact us — we reply quickly.</p>

          <div className="mt-10 divide-y divide-slate-200 rounded-2xl border border-slate-200/70 bg-white aarogya-shadow">
            {items.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.id}>
                  <button className="w-full flex items-center justify-between text-left px-5 py-4 hover:bg-slate-50 transition"
                          onClick={() => setOpen(isOpen ? null : i)}
                          data-testid={`faq-toggle-${i}`}>
                    <span className="font-semibold text-slate-800">{f.question}</span>
                    <ChevronDown className={`h-5 w-5 text-slate-400 transition ${isOpen ? "rotate-180" : ""}`} />
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-slate-600 leading-relaxed" data-testid={`faq-answer-${i}`}>
                      {f.answer}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
